import React from 'react';
import styled from 'styled-components';
import ReactGA from 'react-ga4';
import { Form } from 'react-bootstrap';
import { Card, Heading, Kicker, SearchInput, Subheading } from '../../components/ui';

interface ISearch {
  sentimentAnalyzer: (keyword: any) => void;
  setQueryText: any;
  isLoading: any;
  queryText: any;
}

const SearchArea = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 clamp(0.75rem, 3vw, 1rem);
`;


const SearchCard = styled(Card)`
  padding: 1.35rem 1.25rem 1.5rem;

  h2 {
    margin: 0 0 1rem;
    color: #f8fafc;
    font-size: clamp(1rem, 2vw, 1.15rem);
    font-weight: 600;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
  }
`;

const SearchFormContainer = styled(Form)`
  margin: 0;
`;

const Search: React.FC<ISearch> = (props) => {
  return (
    <SearchArea>
      <Kicker align="center">Agency corpus · NLP</Kicker>
      <Heading level={1} size="xl" align="center" accentText="sentiment analysis" italicAccent>
        Environmental
      </Heading>
      <Subheading align="center" style={{ margin: '0 auto 1.5rem', maxWidth: '520px' }}>
        Analyzes environmental agency files with machine learning to surface positive and negative
        sentiment signals.
      </Subheading>
      <SearchCard>
        <h2>Company, person, or keywords</h2>
        <SearchFormContainer
          onSubmit={(event: React.FormEvent) => {
            event.preventDefault();
            ReactGA.event({
              category: 'Search',
              action: 'Sentiment Search Query',
              label: props.queryText,
              value: 1,
            });
            props.sentimentAnalyzer('doc_sentiment_score_avg-desc');
            props.sentimentAnalyzer('doc_sentiment_score_avg-asc');
          }}
        >
          <SearchInput
            value={props.queryText}
            onChange={props.setQueryText}
            onSubmit={() => {
              props.sentimentAnalyzer('doc_sentiment_score_avg-desc');
              props.sentimentAnalyzer('doc_sentiment_score_avg-asc');
            }}
            loading={props.isLoading}
            placeholder="e.g. facility name, permit ID, enforcement topic…"
            ariaLabel="Run sentiment search"
            variant="glass"
            size="lg"
          />
        </SearchFormContainer>
      </SearchCard>
    </SearchArea>
  );
};

export default Search;
